import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, MapPin, Calendar, Phone } from "lucide-react";
import { MotifDivider } from "../components/Motif";

export default function OrderConfirmation() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${id}`).then((r) => setOrder(r.data));
  }, [id]);

  if (!order) {
    return <div className="px-6 py-24 text-center">Loading…</div>;
  }

  return (
    <div className="px-6 md:px-12 lg:px-20 py-16 md:py-24 fade-up" data-testid="order-confirmation-page">
      <div className="max-w-2xl mx-auto text-center">
        <CheckCircle2 size={48} className="mx-auto text-[var(--srishti-saffron)]" />
        <span className="eyebrow mt-6 block">Enquiry received</span>
        <h1 className="font-serif-display text-4xl md:text-5xl mt-3">
          Thank you, {order.customer_name.split(" ")[0]}.
        </h1>
        <p className="mt-4 text-[var(--srishti-text-secondary)]">
          We&apos;ve received your enquiry and will call shortly with prices and availability.
        </p>

        <p className="mt-8 inline-block text-xs uppercase tracking-widest font-semibold bg-[var(--srishti-bg-alt)] border border-[var(--srishti-border)] px-4 py-2">
          Enquiry #{" "}
          <span className="text-[var(--srishti-maroon)]" data-testid="order-number">
            {order.order_number}
          </span>
        </p>

        <MotifDivider />

        <div className="text-left bg-[var(--srishti-bg-alt)] border border-[var(--srishti-border)] p-6 md:p-8 space-y-4">
          <div className="flex gap-3">
            <MapPin className="text-[var(--srishti-saffron)] mt-0.5 shrink-0" size={18} />
            <div>
              <p className="font-semibold">Pickup at</p>
              <p className="text-sm text-[var(--srishti-text-secondary)]">
                Srishti Gift &amp; Religious Articles Shop, TC Palya, Bangalore
              </p>
            </div>
          </div>
          <div className="flex gap-3">
            <Calendar className="text-[var(--srishti-saffron)] mt-0.5 shrink-0" size={18} />
            <div>
              <p className="font-semibold">When</p>
              <p className="text-sm text-[var(--srishti-text-secondary)]">
                {order.pickup_date} · {order.pickup_slot}
              </p>
            </div>
          </div>
          <div className="flex gap-3">
            <Phone className="text-[var(--srishti-saffron)] mt-0.5 shrink-0" size={18} />
            <div>
              <p className="font-semibold">Pricing &amp; payment</p>
              <p className="text-sm text-[var(--srishti-text-secondary)]">
                We&apos;ll call you with the final price. Cash on pickup.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10">
          <Link to="/shop" className="btn-outline-gold" data-testid="continue-shopping-button">
            Continue Browsing
          </Link>
        </div>
      </div>
    </div>
  );
}
